export default "__VITE_ASSET__Dp$_77Jz__"